/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_EmptyInputs */

const cs_links_empty = /** @type {(inputs: Links_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné odkazy.`)
};

const en_links_empty = /** @type {(inputs: Links_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No links yet.`)
};

/**
* | output |
* | --- |
* | "No links yet." |
*
* @param {Links_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_empty = /** @type {((inputs?: Links_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_empty(inputs)
	return cs_links_empty(inputs)
});